module.exports = ":host /deep/ tbody td:nth-of-type(3) span {\n  white-space: pre-line; }\n\n:host /deep/ th:nth-of-type(2) {\n  min-width: 60px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/logging/error-logs/error-logs.component.scss
// module id = ./src/app/components/framework/logging/error-logs/error-logs.component.scss
// module chunks = main